import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import WhoWeWorkWith from './components/WhoWeWorkWith';
import AgentBasedO1 from './components/AgentBasedO1';
import OurRole from './components/OurRole';
import Approach from './components/Approach';
import Consultation from './components/Consultation';
import WhyAven from './components/WhyAven';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <WhoWeWorkWith />
      <AgentBasedO1 />
      <OurRole />
      <Approach />
      <Consultation />
      <WhyAven />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
